'use es6';

import { Component } from 'react';

/**
 * Radial progress bar. Pass in 'score' prop (0 -> 100) to set the
 * value of the progress bar. Any 'children' HTML will be put inside the
 * radial.
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class RadialProgressBar extends Component {
  constructor(...args) {
    super(...args);
    this.alignProgressBar = score => {
      const changeTrasformRotateZ = (element, deg) => {
        element.style.transform = `rotateZ(${deg}deg)`;
        element.style.webkitTransform = `rotateZ(${deg}deg)`;
      };
      if (score <= 66) {
        const leftDeg = -Math.abs(180 - Math.round(2.7 * score));

        // No need to move the right, only the left
        changeTrasformRotateZ(this.refs.leftSectionWedge, leftDeg);
        changeTrasformRotateZ(this.refs.markerEnd, leftDeg);
      } else {
        // Bring the left section up to full
        changeTrasformRotateZ(this.refs.leftSectionWedge, 0);
        const rightDeg = -90 - (100 - score) * 2.7;

        // Move the right section
        changeTrasformRotateZ(this.refs.rightSectionWedge, rightDeg);
        changeTrasformRotateZ(this.refs.markerEnd, 180 + rightDeg);
      }
    };
  }
  componentDidMount() {
    const score = parseInt(this.props.score, 10);
    this.alignProgressBar(score);
  }

  /**
   * Align the progress bar with the score prop passed in.
   */

  /**
   * Change the transform prop of the element, rotating the Z axis.
   */

  render() {
    return /*#__PURE__*/_jsxs("div", {
      className: "radial-container",
      "data-reagan-selector": "radial-container",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "radial-wrapper",
        children: [/*#__PURE__*/_jsx("div", {
          className: "radial-section radial-right-section",
          children: /*#__PURE__*/_jsx("div", {
            className: "wedge"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "radial-section radial-left-section",
          children: /*#__PURE__*/_jsx("div", {
            className: "wedge"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "marker start"
        }), /*#__PURE__*/_jsx("div", {
          className: "marker end"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "radial-wrapper radial-progress-wrapper",
        children: [/*#__PURE__*/_jsx("div", {
          className: "radial-section radial-right-section",
          children: /*#__PURE__*/_jsx("div", {
            className: "wedge",
            ref: ref => {
              if (ref === null) {
                delete this.refs.rightSectionWedge;
              } else {
                this.refs.rightSectionWedge = ref;
              }
            }
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "radial-section radial-left-section",
          children: /*#__PURE__*/_jsx("div", {
            className: "wedge",
            ref: ref => {
              if (ref === null) {
                delete this.refs.leftSectionWedge;
              } else {
                this.refs.leftSectionWedge = ref;
              }
            }
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "marker start"
        }), /*#__PURE__*/_jsx("div", {
          className: "marker end",
          ref: ref => {
            if (ref === null) {
              delete this.refs.markerEnd;
            } else {
              this.refs.markerEnd = ref;
            }
          }
        }), /*#__PURE__*/_jsx("div", {
          className: "radial-inner-container",
          children: this.props.children
        })]
      })]
    });
  }
}